import { CircularProgress } from '@mui/material'

const Loader = () => {
  return <CircularProgress color='secondary' />
}

export default Loader
